module.exports = __webpack_public_path__ + "static/media/logonav2.979ed714.png";